<template>
<ul class="menu">
	<li v-for="(item,i) in aList" @click="fnSetMenu([i,-1])">
		<router-link :to="item.url" class="level1" :class="(i==aNowMenu[0])?'current':''"><i class="fa" :class="aStylist[i]"></i>{{ item.name }}</router-link>
		<ul v-if="item.submenu.length>0" :class="(i==aNowMenu[0])?'current'+item.submenu.length:''">
			<li v-for="(subitem, j) in item.submenu" @click.stop="fnSetMenu([i,j])"><router-link :to="subitem.url"  :class="(j==aNowMenu[1])?'active':''"><i class="fa fa-circle-o"></i>{{subitem.name}}</router-link></li>
		</ul>
	</li>
</ul>
</template>

<script>
import cons from '@/components/constant'

export default {
  name: 'Menu',
  data () {
    return {
      aList: [
      	{'name':'首 页','url':'/home','submenu':[]},
      	// {'name':'用户管理','url':'','submenu':[
        //   {'name':'用户列表','url':'/home/user'},
        //   {'name':'用户审核','url':'/home/userAudit'}
        // ]},
        {'name':'信息管理','url':'','submenu':[
        //   {'name':'频道管理','url':'/home/channels'},
          // {'name':'内容管理','url':'/home/content'},
          {'name':'内容审核','url':'/home/contentAudit'}
        ]},
        // {'name':'数据统计','url':'','submenu':[
        //   {'name':'网站统计','url':'/home/websiteStatistics'},
        //   {'name':'内容统计','url':'/home/contentStatistics'}
        // ]},
      	// {'name':'系统管理','url':'','submenu':[
        //   {'name':'管理员管理','url':'/home/admin'},
        //   {'name':'角色管理','url':'/home/role'},
        //   {'name':'权限管理','url':'/home/power'},
        //   {'name':'运营日志','url':'/home/operationLog'},
        //   {'name':'个人信息','url':'/home/perInfo'},
        //   {'name':'修改密码','url':'/home/reSetPWD'}
      	// ]},
        // {'name':'推荐系统','url':'','submenu':[
        //   {'name':'敏感词设置','url':'/home/sensitiveSet'},
        //   {'name':'用户画像','url':''},
        //   {'name':'文章画像','url':''}
        // ]}
      ],
      aStylist:['fa-home fa-lg','fa-user fa-lg','fa-shopping-basket','fa-list-alt','fa-gear fa-lg','fa-key fa-lg','fa-newspaper-o','fa-address-card-o','fa-truck fa-lg'],
      aNowMenu:[0,0]
    }
  },
  methods:{
  	fnSetMenu:function(arr){
  		this.aNowMenu = [arr[0],arr[1]];
  	},
    fnResetMenu:function(url){

      if(url=='/home'){
        this.fnSetMenu([0,0])
      }
      if(url=='/home/user'){
        this.fnSetMenu([1,0])
      }
      if(url=='/home/userAudit'){
        this.fnSetMenu([1,1])
      }
      if(url=='/home/channels'){
        this.fnSetMenu([2,0])
      }
      if(url=='/home/content'){
        this.fnSetMenu([2,1])
      }
      if(url=='/home/contentAudit'){
        this.fnSetMenu([2,2])
      }

      // if(url=='/home/imgAudit'){
      //   this.fnSetMenu([3,2])
      // }
      if(url=='/home/websiteStatistics'){
        this.fnSetMenu([3,0])
      }
      if(url=='/home/contentStatistics'){
        this.fnSetMenu([3,1])
      }
      if(url=='/home/admin'){
        this.fnSetMenu([4,0])
      }
      if(url=='/home/role'){
        this.fnSetMenu([4,1])
      }
      if(url=='/home/power'){
        this.fnSetMenu([4,2])
      }
      if(url=='/home/operationLog'){
        this.fnSetMenu([4,3])
      }
      if(url=='/home/perInfo'){
        this.fnSetMenu([4,4])
      }
      if(url=='/home/reSetPWD'){
        this.fnSetMenu([4,5])
      }
      if(url=='/home/sensitiveSet'){
        this.fnSetMenu([5,0])
      }

    }
  },
  watch:{
    $route(to,from){
      this.fnResetMenu(to.path);
    }
  },
  mounted(){
    // 根据权限修改菜单
    var token = localStorage.token
    this.axios.get(cons.apis + '/v1_0/administrators/'+ localStorage.user_id, {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{

        this.axios.get(cons.apis + '/v1_0/groups/'+dat.data.data.group_id, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            // console.log(dat)
            var arr = []
            for(var i=0;i<dat.data.data.permission_tree.length;i++){
              if(dat.data.data.permission_tree[i].checked === 1){
                arr.push(dat.data.data.permission_tree[i].name)
              }
              for(var j=0;j<dat.data.data.permission_tree[i].children.length;j++){
                if(dat.data.data.permission_tree[i].children[j].checked === 1){
                  arr.push(dat.data.data.permission_tree[i].children[j].name)
                }
              }
            }

            // // 放开那个女孩儿...
            // for(var i=0;i<this.aList.length;i++){
            //   if(arr.indexOf(this.aList[i].name) === -1){
            //     this.aList.splice(i,1)
            //   }
            //   if(this.aList[i].submenu!==undefined){
            //     for(var j=0;j<this.aList[i].submenu.length;j++){
            //       if(arr.indexOf(this.aList[i].submenu[j].name) === -1){
            //         this.aList[i].submenu.splice(i,1)
            //       }
            //     }
            //   }
            // }

            // console.log(this.aList)

        }).catch(err=>{
           console.log(err);
        });




      }).catch(err=>{
         console.log(err.response);
      });

    // 加载菜单
    var starturl = this.$route.path;
    this.fnResetMenu(starturl);
  }
}
</script>

<style scoped>
.menu{
  width:210px;
  margin:0px auto;
}
.menu .level1,.menu li ul a{
  display:block;
  width:210px;
  line-height:40px;
  text-decoration:none;
  color:#fff;
  font-size:14px;
  text-indent:10px;
}
.menu li ul a{
  font-size:14px;
  text-indent:20px;
  background-color:#252934;
}
.menu li .level1:hover{
  background-color:#fb5557;
}
.menu li a.current{
  background-color:#fb5557;
}
.menu li ul{
  height:0px;
  overflow:hidden;
  transition:all 300ms ease;
}
.menu li ul.current1{
	height:40px;
}
.menu li ul.current2{
	height:80px;
}
.menu li ul.current3{
	height:120px;
}
.menu li ul.current4{
	height:160px;
}
.menu li ul.current5{
  height:200px;
}
.menu li ul.current6{
  height:240px;
}
.menu li ul.current7{
  height:280px;
}
.menu li ul li a:hover{
  color:#fb5557;
}
.menu li ul li a.active{
   color:#fb5557
}
.menu li .fa{
  margin-right:20px;
}
.menu li li .fa{
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/Menu.vue